import { useMemo } from 'react';

// Maps app screen names to admin screen ids
const SCREEN_MAP = {
  list: 'mygear',
};

const parseDate = (val) => {
  if (!val) return null;
  if (typeof val.toDate === 'function') return val.toDate(); // Firestore Timestamp
  return new Date(val);
};

// Dev-only escape hatch — set REACT_APP_RESET_MESSAGES=true in
// .env.development so messages keep showing during testing instead of
// disappearing forever the moment you dismiss one. Always false in
// .env.production, so production behaviour is untouched.
const devResetMessages = process.env.REACT_APP_RESET_MESSAGES === 'true';

export default function useMessages(festival, group, currentScreen) {
  return useMemo(() => {
    const messages = festival?.messages;
    if (!messages || !group) return [];

    const now = new Date();
    const mappedScreen = SCREEN_MAP[currentScreen] || currentScreen;

    return messages
      .filter((msg) => {
        if (!msg.active) return false;
        if (!msg.imageUrl) return false;
        // Mirrors MessageModal.js's dismiss key — messages without a stable
        // id (added via the admin panel before it assigned one) fall back
        // to imageUrl, which is already guaranteed present by the check above.
        const dismissKey = msg.id || msg.imageUrl;
        if (!devResetMessages && group.dismissedMessages?.includes(dismissKey)) return false;

        const from = parseDate(msg.showFrom);
        const until = parseDate(msg.showUntil);
        if (from && now < from) return false;
        if (until && now > until) return false;

        const screens = msg.screens || [];
        if (screens.length > 0 && !screens.includes('all') && !screens.includes(mappedScreen)) {
          return false;
        }

        return true;
      })
      .sort((a, b) => {
        const aTime = parseDate(a.showFrom)?.getTime() ?? 0;
        const bTime = parseDate(b.showFrom)?.getTime() ?? 0;
        return bTime - aTime;
      });
  }, [festival, group, currentScreen]);
}
